<div class="flex items-center justify-between">
  <h1
    class="pb-5 font-brand text-28px font-bold text-neutral-800"
    translate="como.link-account.header"
  ></h1>
  <app-rounded-icon-button
    icon="icon-cross"
    (onClick)="onClose.emit($event)"
  ></app-rounded-icon-button>
</div>

<form [formGroup]="form">
  <label
    for="phone"
    class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600"
    translate="signup.phone"
  ></label>
  <label
    for="comoRegistrationPhoneInput"
    class="mb-2 block font-base text-xs font-normal text-neutral-500"
    translate="como.help-phone-format"
  >
  </label>

  <input
    id="comoRegistrationPhoneInput"
    type="tel"
    formControlName="phone"
    class="flex w-full border border-solid border-neutral-300 bg-neutral-50 px-5 py-8xs font-base text-base font-normal leading-5"
    [class.border-error-700]="errorMessage"
  />

  <div class="hidden kiosk:block">
    <app-numeric-keypad-atom
      (numberClick)="onKeypadNumberClick($event)"
      (deleteClick)="onKeypadDeleteClick()"
    ></app-numeric-keypad-atom>
  </div>

  <div
    class="mt-2 font-base text-xs font-normal text-error-700"
    *ngIf="errorMessage"
    [translate]="errorMessage"
  ></div>

  @if (form.controls.phone.errors?.maxlength) {
    <div
      class="mt-2 font-base text-xs font-normal text-error-700"
      [translate]="'signup.phone.maxlength-error'"
    ></div>
  }

  <div class="mt-10 flex flex-col">
    <app-button-atom
      size="L"
      [label]="'como.validate' | translate"
      [iconUrl]="isValidating ? 'assets/images/spinner.svg' : ''"
      [disabled]="isValidating || !form.valid"
      type="primary"
      [overrideBgColor]="accentColor?.background"
      [full]="true"
      (click)="onRegister()"
    ></app-button-atom>
  </div>
</form>
